// extracted by mini-css-extract-plugin
export default {"premiumButton":"premiumPredloziButton_premiumButton__Vi1JO"};